"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ContentLine_1 = require("../../contentLine/ContentLine");
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var VehicleSummary = function (_a) {
    var bodyStyle = _a.bodyStyle, nameplate = _a.nameplate, interior = _a.interior, exterior = _a.exterior, transmission = _a.transmission;
    var isFromAltSpc = core_1.useTheme().checkoutLite.isFromAltSpc;
    var intl = react_intl_1.useIntl();
    var exteriorWithTranslation = intl.formatMessage({ id: 'carDetails.label.exteriorLabel' }) + exterior;
    var interiorWithTranslation = intl.formatMessage({ id: 'carDetails.label.interiorLabel' }) + interior;
    return (<>
      {bodyStyle && <ContentLine_1.default mainContent={bodyStyle} dataTest="summary:vehicle:body_style"/>}
      {nameplate && <ContentLine_1.default mainContent={nameplate} dataTest="summary:vehicle:nameplate"/>}
      <ContentLine_1.default mainContent={isFromAltSpc ? exteriorWithTranslation : exterior} dataTest="summary:vehicle:exterior"/>
      <ContentLine_1.default mainContent={isFromAltSpc ? interiorWithTranslation : interior} dataTest="summary:vehicle:interior"/>
      <ContentLine_1.default mainContent={transmission} dataTest="summary:vehicle:transmission"/>
    </>);
};
exports.default = VehicleSummary;
